<h2 mat-dialog-title>{{'pass.widgets.types.oneClickPay' | translate}}</h2>

<mat-dialog-content>
    <div class="pt-2 pb-3">
        <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
            <form [formGroup]="itemEditForm">

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'pass.title' | translate}}</mat-label>
                    <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}">
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'tridys.description' | translate}}</mat-label>
                    <input formControlName="description" type="text" matInput placeholder="{{'tridys.description' | translate}}">
                </mat-form-field>
                

                <div class="d-flex flex-row">
                    <div class="pe-2 flex-grow-1">
                        <div class="input-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'pass.oneClickPay.price' | translate}}</mat-label>
                                <input formControlName="priceAmount" type="number" min="0" matInput placeholder="{{'pass.oneClickPay.price' | translate}}">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="ps-2 flex-grow-1">
                        <div class="input-group">

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'pass.oneClickPay.currency' | translate}}</mat-label>
                                <mat-select formControlName="priceCurrency" required>
                                    <mat-option value="euro" ><mat-icon>euro</mat-icon> {{'euro' | translate}}</mat-option>
                                    <mat-option value="pound" > <mat-icon>currency_pound</mat-icon> {{'pound' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                    </div>
                </div>

            </form>
        </section>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" [mat-dialog-close]="[false,oldData]" >{{'cancel' | translate}}</button>
    <button mat-button class="orange-button" (click)="saveChanges();" [disabled]="itemEditForm.invalid" >{{'apply' | translate}}</button>
</mat-dialog-actions>